import * as Yup from 'yup';

import { FormVariant } from '../../enums/variant.enum';

interface ReportWorkflowLike {
  readonly _id: unknown;
  readonly initAction: Readonly<{
    settings: Readonly<{ autoCreateDocumentIfNotExists: boolean | null }>;
  }>;
}

export const getMissionReportInfoSchema = (
  formVariant: FormVariant,
  reportWorkflows: readonly ReportWorkflowLike[],
) =>
  Yup.lazy((values: { info?: { workflowId?: unknown } }) => {
    const willCreateDocumentImmediately =
      formVariant === FormVariant.Creation &&
      !!reportWorkflows.find(
        (workflow) => workflow._id === values.info?.workflowId,
      )?.initAction.settings.autoCreateDocumentIfNotExists;

    const isTitleRequired =
      formVariant === FormVariant.Modification || willCreateDocumentImmediately;

    return Yup.object().shape({
      title: isTitleRequired
        ? Yup.string().required('Le titre est requis')
        : Yup.string().optional(),
      codingConfig: Yup.object().shape({
        code: willCreateDocumentImmediately
          ? Yup.string().required('Le code est requis')
          : Yup.string().optional(),
      }),
    });
  });
